import { MARQUEE_WORDS } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_WORDS.map((word, i) => (
      <span key={word} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 font-serif text-4xl font-medium tracking-tight md:px-12 md:text-6xl ${
            i % 2 === 0 ? "italic text-white/90" : "marquee-outline"
          }`}
        >
          {word}
        </span>
        <span className="text-xl text-brand-bright md:text-2xl" aria-hidden="true">
          ·
        </span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-white/10 bg-navy py-7 md:py-9"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
